export function contextLevelFromUrl() {
	const path = window.location.pathname;
	if (path.includes("place") && !path.includes("event")) return "place";
	if (path.includes("event")) return "event";
	return "organization";
}
